import { render, staticRenderFns } from "./InquiriesViewInquiries.vue?vue&type=template&id=ae71cddc"
import script from "./InquiriesViewInquiries.vue?vue&type=script&lang=js"
export * from "./InquiriesViewInquiries.vue?vue&type=script&lang=js"
import style0 from "./InquiriesViewInquiries.vue?vue&type=style&index=0&id=ae71cddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports